import { cloneDeep } from 'lodash';
import {
  DocumentationDeliveryMethod,
  GuarantorLocationType,
  IndependentAdviceTypeRequired,
} from '@lendi/core-constants';

import { BrokerInterviewsGuarantorWithId } from '@funnels/types';

export const BROKER_INTERVIEW_GUARANTOR_MOCK_DATA: BrokerInterviewsGuarantorWithId[] = [
  {
    applicantId: 'applicant-1',
    hasBrokerDeclaration: true,
    confirmCouldMeetLoanRepayments: true,
    confirmWouldSellFamilyHome: true,
    independentAdviceTypeRequired: IndependentAdviceTypeRequired.legalAdvice,
    isOnlyPersonPresent: true,
    location: GuarantorLocationType.faceToFace,
    locationDescription: 'Description about location',
    understandsGuaranteeSigningPeriod: true,
    understandsSecurityGuarantee: true,
    understandsEnglish: true,
    documentationDeliveryMethod: DocumentationDeliveryMethod.email,
    isUnderPowerOfAttorney: true,
    hasLenderSpecificBrokerDeclaration: true,
    interviewDate: '2021-12-15',
  },
];

export const getMockBrokerInterviewsGuarantor = (): BrokerInterviewsGuarantorWithId[] =>
  cloneDeep(BROKER_INTERVIEW_GUARANTOR_MOCK_DATA);
